import './App.css';
import React, { useState, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from '../components/Header/Header';
import MajorCourse from '../pages/Majorcourse/MajorCourse';
import Courses from '../pages/Majorcourse/AllCourses/Courses';
import Dashboard from '../pages/Dashboard/Dashboard';
import LandingPage from '../pages/LandingPage/LandingPage';
import Course from '../pages/Course/Course';
import Print from '../pages/StudentCourse/Print/Print';
import Report from '../pages/StudentCourse/Report/Report';
import Order from '../pages/Order/Order';
import CreateCourse from '../pages/Course/Create/Create';
import Login from '../pages/Login/Login';
import UploadFile from '../pages/UploadFile/UploadFile';
import EditStudent from '../pages/Student/Edit/Student';
import UnitDashboard from '../pages/Unit/Unit';
import SpcDashboard from '../pages/Spc/Spc';
import AdminDashboard from '../pages/Admin/Admin';
import EditStudentCourse from '../pages/StudentCourse/Edit/StudentCourse';
import ConfirmationStudentCourse from '../pages/StudentCourse/Confirmation/StudentCourse';
import useToken from './useToken';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [isUserType, setIsUserType] = useState(true);
  const [userToken, setUserToken] = useState();
  const { token, getToken, setToken, checkToken, forceLogout, isStudent } = useToken(setIsLoading);
  const isUserStudent = isStudent();

  useEffect(() => {
    setUserToken(getToken());
    const isConfirmationPage = window.location.pathname.split('/').pop() == 'confirmation';
    if (isConfirmationPage) {
      setIsUserType(false);
      checkToken('student')
    } else {
      setIsUserType(true);
      checkToken('user')
    }
    setIsLoading(false);
  }, []);  

  useEffect(() => {
    setUserToken(getToken());
  }, [token]);

  return (
    <>
      {!userToken && !isLoading && <>
         <Login setToken={setToken} isUserType={isUserType} />
      </>}
      {userToken && !isLoading && <>
        <Header forceLogout={forceLogout} />
        <div className="wrapper">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
          <BrowserRouter>
            <Routes>
              {!isUserStudent && <>
                <Route exact path="/majorcourses" element={<MajorCourse />}></Route>
                <Route exact path="/dashboard" element={<Dashboard />}></Route>
                <Route exact path="/majorcourses/:major_name" element={<Courses />}></Route>
                <Route exact path="/majorcourses/:major_name/course/:course_name" element={<Course />}></Route>
                <Route exact path="/majorcourses/:major_name/course/:course_name/print" element={<Print />}></Route>
                <Route exact path="/majorcourses/:major_name/course/:course_name/report" element={<Report />}></Route>
                <Route exact path="/majorcourses/:major_name/course/:course_name/requestOrder" element={<Order />}></Route>
                <Route exact path="/majorcourses/:major_name/course/create" element={<CreateCourse />}></Route>
                <Route exact path="/students/:id/edit" element={<EditStudent />}></Route>
                <Route exact path="/studentcourse/:id/edit" element={<EditStudentCourse />}></Route>
                <Route exact path="/uploadfile" element={<UploadFile />}></Route>
                <Route exact path="/units/:id" element={<UnitDashboard />}></Route>
                <Route exact path="/spcs/:id" element={<SpcDashboard />}></Route>
                <Route exact path="/admin/:id" element={<AdminDashboard />}></Route>
              </>}
              <Route exact path="/course/:course_name/airforceid/:airforce_id/confirmation" element={<ConfirmationStudentCourse />}></Route>
            </Routes>
          </BrowserRouter>
          {window.location.pathname === '/' && <LandingPage /> }
        </div>        
      </>}
    </>
  );
}

export default App;
